// Refine
import { useTranslation } from '@refinedev/core';

// Mantine
import { Badge, useMantineTheme } from '@mantine/core';

// Components
import { formatUploadStatusLabel, getUploadStatusBadgeProps } from './uploadStatus';

interface StatusBadgeProps {
  status?: string | null;
}

export const UploadStatusBadge: React.FC<StatusBadgeProps> = ({ status }) => {
  const theme = useMantineTheme();
  const { translate } = useTranslation();
  const statusKey = status ?? 'toDo';
  const badgeProps = getUploadStatusBadgeProps(statusKey, theme);
  return (
    <Badge radius="sm" size="md" {...badgeProps}>
      {formatUploadStatusLabel(statusKey, translate)}
    </Badge>
  );
};
